export default __webpack_public_path__ + "static/media/icon_histsolicitacoes.a4e88aae.svg";